import { render, staticRenderFns } from "./FormPasswordReset.vue?vue&type=template&id=bf3f01f2&scoped=true&"
import script from "./FormPasswordReset.vue?vue&type=script&lang=js&"
export * from "./FormPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3f01f2",
  null
  
)

export default component.exports